import { render } from "./CyberBtnIA.vue?vue&type=template&id=21cbc6ae&scoped=true"
import script from "./CyberBtnIA.vue?vue&type=script&lang=js"
export * from "./CyberBtnIA.vue?vue&type=script&lang=js"

import "./CyberBtnIA.vue?vue&type=style&index=0&id=21cbc6ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cbc6ae"]])

export default __exports__